export default "__VITE_PUBLIC_ASSET__85cdc329__"